import { useRoutinesFFEnabled } from 'featureFlags/hooks';
import { Show } from 'shared';

type RenderIfRoutinesFFEnabledProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export const RenderIfRoutinesFFEnabled = ({
  children,
  fallback = null,
}: RenderIfRoutinesFFEnabledProps) => {
  const isRoutinesEnabled = useRoutinesFFEnabled();

  return (
    <Show when={isRoutinesEnabled} fallback={fallback}>
      {children}
    </Show>
  );
};
